// IconLoader.js
import telegram from './assets/telegram.png';
import whatsapp from './assets/whatsapp.png';
import share from './assets/share.png';

const icons = {
    telegram,
    whatsapp,
    share,
};

// Optional: force preload in memory
export const preloadIcons = () => {
    Object.values(icons).forEach((src) => {
        const img = new Image();
        img.src = src;
    });
};

export default icons;
